<template>
  <div>
    <div class="cv-item-wrapper" :class="[previewType, data.can_editable || isEditer ? '': 'disable']" @click.stop="editor">
      <!-- 渲染简历图 -->
      <div class="resume-box">
        <img src="https://files.wondercv.com/cvs/default-resume-en.jpg" alt="" class="resume" v-if="data.lang == 'en'" />
        <img src="https://files.wondercv.com/cvs/default-resume-cn.jpg" alt="" class="resume" v-else />
        <!-- 删除简历 -->
        <template v-if="previewType === 'delete'">
          <div class="action-box" @click.stop>
            <button class="cv-item-btn delete" @click.stop="shiftDeleteCvFunc()">彻底删除</button>
            <button class="cv-item-btn recovery" @click.stop="debounce(() => { recoveryCvFunc() }, 300)">恢复文件</button>
          </div>
        </template>
        <!-- 我的简历 -->
        <template v-else>
          <div class="resume-action-icon" @click.stop="toggleShowCvHandleBoxFunc()">
            <span class="iconfont iconmore"></span>
          </div>
          <div class="resume-tip">
            <div class="resume-info">
              <span class="score">{{ data.score === null ? '暂无评分' : `${data.score}分` }}</span>
              <span class="lang">{{ data.lang | langFilter }}</span>
            </div>
            <div class="resume-time">
              最后编辑于：{{data.update_time | timeFormatFilter}}
            </div>
          </div>
          <!-- 开通会员可用 -->
          <div class="disable-icon" v-if="!data.can_editable && !isEditer">开通会员可用</div>
        </template>
        <!-- 导师修改 -->
        <div class="mentor-icon" v-if="data.is_mentor">导师修改</div>
        <div class="mentor-icon" v-else-if="data.ai_mentor">AI导师</div>
      </div>
      <!-- 简历标题 -->
      <div class="resume-name resume-info">
        <h6 class="cv-item-title" v-if="previewType === 'draft'">{{ renameCvName || data.name || data.cv_name || '未命名超级简历' }}</h6>
        <h6 class="cv-item-title" v-else-if="previewType === 'delete'">{{ data.display_name || '未命名超级简历' }}</h6>
        <template v-if="previewType === 'delete'" >
          <span class="score">{{ data.score === null ? '暂无评分' : `${data.score}分` }}</span>
          <span class="lang">{{ data.lang | langFilter }}</span>
        </template>
      </div>
      <!-- 简历时间 -->
      <div class="resume-time" v-if="previewType === 'delete'">
        最后编辑于：{{data.updated_at | timeFormatFilter}}
      </div>

        <!-- 简历 图 -->
        <!-- <img :src="data.is_mentor ? 'https://files.wondercv.com/PC/cvs/myresume_mentor.png' : data.can_editable ? 'https://files.wondercv.com/PC/cvs/myresume_red.png' : 'https://files.wondercv.com/PC/cvs/myresume_gray.png'" alt=""> -->

        <!-- 简历相关信息 -->
        <div class="cv-item-info" style="display: none;">

          <div class="cv-item-line">
            <!-- 简历标题 -->
            <h6 class="cv-item-title" v-if="previewType === 'draft'">{{ renameCvName || data.name || data.cv_name || '未命名超级简历' }}</h6>
            <h6 class="cv-item-title" v-else-if="previewType === 'delete'">{{ data.display_name || '未命名超级简历' }}</h6>
            <!-- 简历操作合集 -->
            <div class="cv-more-handle" @click.stop="toggleShowCvHandleBoxFunc()">
              <span class="cv-item-dot"></span>
            </div>
          </div>

          <div class="cv-item-line">
            <!-- 简历分数和类型 -->
            <div class="cv-item-tag-list">
              <span class="score">{{ data.score === null ? '暂无评分' : `${data.score}分` }}</span>
              <span class="lang">{{ data.lang | langFilter }}</span>
            </div>
            <!-- 简历最后更新时间 -->
            <div class="cv-item-time" v-if="previewType === 'delete'">最后编辑于：{{data.updated_at | timeFormatFilter}}</div>
            <div class="cv-item-time" v-else>最后编辑于：{{data.update_time | timeFormatFilter}}</div>
          </div>

          <div class="cv-item-btn-box" v-if="previewType === 'delete'">
            <button class="cv-item-btn delete" @click.stop="shiftDeleteCvFunc()">彻底删除</button>
            <button class="cv-item-btn recovery" @click.stop="debounce(() => { recoveryCvFunc() }, 300)">恢复文件</button>
          </div>

        </div>

        <!-- 操作浮窗 -->
        <div class="cv-handle-box" ref="cvHandleBox" v-if="handleBoxVisible && previewType === 'draft'">
          <p @click.stop="debounce(() => { dumpCv() }, 300)" v-if="data.can_editable"><i class="iconfont iconfuzhijianli"></i><span>复制简历</span></p>
          <p @click.stop="debounce(() => { checkUserVip() }, 300)"><i class="iconfont iconxiazaijianli"></i><span>下载简历</span></p>
          <p @click.stop="debounce(() => { editCvName(data.token, data.cv_name) }, 300)" v-if="data.can_editable"><i class="iconfont iconxiugaimingcheng"></i><span>修改名称</span></p>
          <p @click.stop="debounce(() => { deleteCv() }, 300)"><i class="iconfont iconshanchujianli"></i><span>删除简历</span></p>
        </div>

    </div>
    <!-- <renameModal v-if='renameModalShow' :cvToken="renameCvToken" :cvName="renameCvName" @editCvName='editCvName'/> -->

    <!-- <select-cv
      :cvsEn="cvsEn"
      :cvsCn="cvsCn"
      v-if="showSelectCv"
      @updated="$emit('triggleCvUpdatedFunc')"
      @close="showSelectCv = false"/> -->

    <!-- <trash-alert :show="alertBox.show" :title="alertBox.title" :button-name="alertBox.buttonName"
                :content="alertBox.content" @confirm="alertBox.confirm" @close="alertBox.show = false"
                :hide-close-btn="alertBox.hideCloseBtn"/> -->
  </div>
</template>

<script>
import api from '@/api'
import axios from 'axios'
import moment from 'moment'
import downloadjs from 'downloadjs'
// import trashAlert from '@/components/trashAlert'
// import renameModal from '@/components/renameModal'
// import selectCv from '@/views/cvs/components/selectCv'
import { routerTo, get_tUser } from '@/assets/js/util'
import { mapState, mapMutations } from 'vuex'
import { componentsMixin } from '@/assets/js/mixins/components'

let run = null

export default {
  props: {
    // 展示类型 目前的可能：1. draft 草稿简历展示 2. delete 已删除简历展示
    previewType: {
      type: String,
      default: 'draft'
    },
    // 单个简历数据
    data: {
      type: Object,
      default: {}
    },
    // 最开始遍历时的简历索引
    indexSelf: {
      type: Number,
      default: 0
    },
    // 活跃浮窗的简历索引
    indexNow: {
      type: Number,
      default: 0
    },
    userLock: {
      type: Boolean,
      default: false
    }
  },
  mixins: [ componentsMixin ],
  data () {
    return {
      moment,
      cvsEn: [], // 中文可用简历 集合
      cvsCn: [], // 英文可用简历 集合
      renameCvToken: '', //重命名简历token
      renameCvName: '', //重命名简历名称
      renameModalShow: false,
      isDumpCv: false, // 是否正在复制简历
      isDownloadCv: false, // 是否正在下载简历
      isDeleteCv: false, // 是否正在删除简历
      showSelectCv: false,
      handleBoxVisible: false, // 操作浮窗的显示和隐藏
      alertBox: {
        show: false,
        title: '清空回收站',
        content: '',
        buttonName: '确定',
        confirm: () => {}
      }
    }
  },
  components: {
    // selectCv,
    // renameModal,
    // trashAlert
  },
  computed: {
    ...mapState('cv', ['cvs']),
    ...mapState('me', [ 'personInfo' ]),
    isMember() {
      return this.personInfo.is_membership
    },
    isEditer() {
      return this.data.is_mentor || this.data.ai_mentor
    },
  },
  filters: {
    langFilter: (value) => {
      if (!value) {
        return ''
      } else {
        return value === 'cn' ? '中' : '英'
      }
    },
    timeFormatFilter: (value) => {
      if(!value) return ''
      let today = moment().format('YYYYMMDD')
      let update = moment(value).format('YYYYMMDD')
      let year = moment().year()
      let updateYear = moment(value).year()
      if (today === update) {
        return moment(value).format('HH:mm')
      } else if (update - 0 === today - 1) {
        return '昨天'
      } else if (update < today - 1 && year === updateYear) {
        return moment(value).format('MM月DD日')
      } else if (updateYear < year) {
        return moment(value).format('YYYY年MM月DD日')
      }
    }
  },
  created(){
    this.renameCvName = this.data.cv_name
  },
  methods: {
    ...mapMutations('cv',['setCvs']),

    // 【draft】切换 操作浮窗的显示和隐藏
    toggleShowCvHandleBoxFunc () {
      if (!!this.userLock) return
      this.$emit('triggleShowCvHandleBoxFunc', this.indexSelf)
      this.handleBoxVisible = !this.handleBoxVisible
    },
    // 【draft】跳转 简历编辑页
    async editor() {
      if (!!this.userLock) return
      if (this.previewType === 'delete') return
      let isSelect = await this.available()
      if (isSelect) {
        return false
      }
      if (!this.data.can_editable && !this.isEditer) {
        // this.showSelectCv = true
        this.$emit('updateSelectCvData', {
          show: true,
          cvsEn: this.cvsEn,
          cvsCn: this.cvsCn
        })
        return false
      }
      routerTo(`/cvs/${this.data.token}/editor`)
    },
    // 【draft】会员过去判断简历可用
    async available() {
      let data = this.data
      if (data.can_editable) {
        return false
      }
      let cvs = this.cvs
      let cvsEn = []
      let cvsCn = []
      let cvsEnDis = 0 // 英文简历的份数
      let cvsCnDis = 0 // 中文简历的份数
      if (!cvs.length) {
        return false
      }
      for (let i = 0; i < cvs.length; i++) {
        if (cvs[i].lang === 'cn' && !cvs[i].is_mentor && !cvs[i].ai_mentor) {
          cvsCn.push(cvs[i])
          if (cvs[i].can_editable) cvsCnDis++
        }
        else if (cvs[i].lang === 'en' && !cvs[i].is_mentor && !cvs[i].ai_mentor) {
          cvsEn.push(cvs[i])
          if (cvs[i].can_editable) cvsEnDis++
        }
      }
      this.cvsEn = cvsEn
      this.cvsCn = cvsCn
      //
      if ((this.data.lang === 'cn' && cvsCnDis === 0) || (this.data.lang === 'en' && cvsEnDis === 0)) {
        // this.showSelectCv = true
        this.$emit('updateSelectCvData', {
          show: true,
          cvsEn: this.cvsEn,
          cvsCn: this.cvsCn
        })
        return true
      } else if ((this.data.lang === 'cn' && cvsCnDis > 0) || (this.data.lang === 'en' && cvsEnDis > 0)) {
        this.$emit('changeConfirmState', this.downloadCv)
        // this.$store.dispatch('app/setAlertData', {
        //   show: true,
        //   type: 'upVip'
        // })
        return true
      }
      return false
    },
    // 【draft】修改简历名称
    editCvName(token, name) {
      this.handleBoxVisible = false
      this.$emit('editCvName', token, name)
      // this.renameCvToken = token
      // this.renameCvName = name
      // this.renameModalShow = !!token
    },
    // 【draft】删除简历
    deleteCv() {
      this.handleBoxVisible = false
      const alertData = {
        show: true,
        type: 'message',
        messageTitle: '删除提示',
        showCancelButton: true, //取消按钮
        showConfirmButton: true, // 确定按钮
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        cancelButtonClass: 'cvs-edit-cancelButtonClass',
        confirmButtonClass: 'cvs-edit-confirmButtonClass',
        isDarkTheme: true, // 是否是深色主题
        messageContent: `
          <p>删除后可在「回收站」中找回最近删除的简历，确定要删除当前简历吗?</p>
        `,
        confirm: async close => {
          if (this.isDeleteCv) {
            return false
          }
          this.isDeleteCv = true
          let loading = this.$message({
            iconClass: 'el-icon-loading',
            duration: 0,
            message: '正在删除'
          })
          let res = await api.cvsEditor.deleteCv(this.data.token)
          if (res.code === 1000) {
            this.$message.success('删除成功')
            //同步到vuex,整理删除之后的数据
            let cvsList = this.cvs.filter(item=>item.token!==this.data.token)
            this.setCvs(cvsList)
            // this.$store.commit('cvs/GET_CVS', [])
            close()
            this.$emit('triggleCvUpdatedFunc')
          } else {
            this.$message.error(res.message)
            close()
          }
          this.isDeleteCv = false
          loading.close()
        },
        cancel: async close => {
          close()
        }
      };
      this.$store.dispatch('app/setAlertData', alertData)
    },
    // 【draft】复制简历
    async dumpCv() {
      clearTimeout(run)
      run = setTimeout(async () => {
        if (this.isDumpCv) {
          return false
        }
	      let { c_t } = get_tUser()
	      this.isDumpCv = true
	      let createCv = await api.cvsEditor.canCreateCv(c_t)
	      if (createCv.code === 1000) {
		      if (createCv.data[`can_create_${ this.data.lang }_cv`]) {
			      let loading = this.$message({
				      iconClass: 'el-icon-loading',
				      duration: 0,
				      message: '正在复制'
			      })
			      let params = {
				      cv_token: this.data.token
			      };
			      let res = await api.cvsEditor.duplicateCvs(params)
			      if (res.code === 1000) {
              this.handleBoxVisible = false
				      this.$message.success('复制成功')
				      //同步到vuex,整理删除之后的数据
				      // let cvsList = this.cvs.filter(item=>item.token!==this.data.token)
				      // this.setCvs(cvsList)
				      this.$emit('triggleCvUpdatedFunc')
			      } else {
				      this.$message.error(res.message)
				      if (res.code === 3001) {
					      this.$store.dispatch('app/setAlertData', {
						      show: true,
						      type: 'upVip',
                  browseType: 'cvCardCopy'
					      })
				      }
			      }
			      this.isDumpCv = false
			      loading.close()
		      } else {
			      if (this.personInfo.is_membership) {
				      this.$message.error('已达简历数量上限')
			      } else {
				      this.$store.dispatch('app/setAlertDataShow', false)
				      this.$message.error('已达简历上限，升级会员可创建多份简历')
				      setTimeout(() => {
					      this.$store.dispatch('app/setAlertData', {show: true, type: 'upVip', browseType: 'cvCardCopy'})
				      }, 300)
			      }
			      this.isDumpCv = false
		      }
	      } else {
		      this.isDumpCv = false
		      console.log('接口报错')
	      }
      }, 300)
    },
    // 非会员下载简历阻断弹窗
    async checkUserVip() {
      try {
        const params = {
          origin: "pc",
        };
        const { code, data } = await api.account.checkUseVip(this.data.token, params);
        if (code === 1000 && !data?.use_vip && !this.isMember) {
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'upVip',
            displayContinueBtn: true,
            downloadContinue: this.downloadCv
          })
        } else {
          this.downloadCv()
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 【draft】下载简历
    async downloadCv() {
      if (this.isDownloadCv) {
        return false
      }
      this.isDownloadCv = true
      let downloadLoading =  this.$message({
        message: '正在下载',
        iconClass:'el-icon-loading',
        duration:0,
      });

      let params = {
      	watermark: 'no',
        showProfile: true,
        pageNum: 1,
        origin: 'pc'
      }
      let res = await api.cvsEditor.downloadCv(this.data.token, params)
      // 会员阻断
      if(res.code === 80160) {
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'upVip'
        })
        this.isDownloadCv = false
        downloadLoading.close()
        return false
      }
      if (!res.data.url) {
        this.$message.error('下载失败')
        this.isDownloadCv = false
        downloadLoading.close()
        return false
      }
      axios({
        url: res.data.url,
        method: 'get',
        responseType: 'blob'
      }).then(r => {
        downloadjs(r.data, this.data.cv_name + ".pdf", "pdf")
        this.isDownloadCv = false
        this.handleBoxVisible = false
        downloadLoading.close()
        this.$message.success('下载成功')
      }).catch(err => {
        this.isDownloadCv = false
        downloadLoading.close()
        this.$message.error('下载失败')
      })
    },
    // 【delete】 彻底删除简历
    shiftDeleteCvFunc() {
      let { token } = this.data
      let run = false
      this.alertBox = {
        show: true,
        isDarkTheme: true, // 是否是深色主题
        buttonName: '删除',
        title: '彻底删除简历',
        content: '即将彻底删除 1 个简历。删除后将无法恢复，请谨慎操作！',
        isDarkTheme: true, // 是否是深色主题
        confirm: async () => {
          clearTimeout(run)
          run = setTimeout(async () => {
            let params = {}
            api.trash.deleteCv(this.$axios, params, token)
              .then(res => {
                this.$set(this.alertBox, 'show', false)
                if (res.code === 1000) {
                  this.$message.success('简历删除成功')
                  this.$emit('triggleUpdateDeleteCvListFunc')

                } else {
                  this.$message.error('简历删除失败')
                }
              })
              .catch(err => {
                this.$message.error('服务器打盹了...')
              })
            this.$emit('updataTrashAlertBox', {show: false})
          }, 300)
        }
      }
      this.$emit('updataTrashAlertBox', this.alertBox)
    },
    // 【delete】 恢复文件
    async recoveryCvFunc() {
      let { token } = this.data
      let params = {
        operation_type: 'recovery'
      }
      await api.trash.recoveryCv(this.$axios, params, token)
        .then(res => {
          if (res.code === 1000) {
            this.$message.success('简历恢复成功')
            // 更新回收站简历列表
            this.$emit('triggleUpdateDeleteCvListFunc')
            // 更新草稿简历列表
            this.$emit('triggleCvUpdatedFunc')
          } else if (res.code === 3000) {
            this.alertBox = {
              show: true,
              isDarkTheme: true, // 是否是深色主题
              title: '恢复文件提示',
              content: '简历数量已达上限，需删除其他简历才能恢复该简历。',
              buttonName: '知道了',
              hideCloseBtn: true,
              confirm: () => {
                this.alertBox = {}
                this.$emit('updataTrashAlertBox', {show: false})
              }
            };
            this.$emit('updataTrashAlertBox', this.alertBox)
          } else if (res.code === 3001) {
            this.alertBox = {
              show: true,
              isDarkTheme: true, // 是否是深色主题
              title: '恢复文件提示',
              content: '当前有效简历已达上限，开通会员即可恢复更多简历！',
              buttonName: '开通会员',
              confirm: async () => {
                // let params = await dealSignatrue({
                //   client: process.env.CLIENT
                // });
                // await api.me.orderCreateByMembership(params)
                //   .then(res => {
                //     if (res.status === 1) {
                //       routerTo('/orders/' + res.data.order_token);
                //     }
                //   })
                // routerTo('/account/users/buy_member')
                // 关闭现在的弹窗
                this.$emit('updataTrashAlertBox', {show: false})
                // 打开会员购买弹窗
                this.$store.dispatch('app/setAlertData', {
                  show: true,
                  type: 'upVip',
                  displayContinueBtn: true,
                })
              }
            };
            this.$emit('updataTrashAlertBox', this.alertBox)
          }
        }).catch(err => {
          this.$message.error('服务器打盹了...')
        })
    }

  },
  watch: {
    indexNow (newVal, oldVal) {
      if (newVal === this.indexSelf) {

      } else {
        // 自己不是目前活跃的简历索引 则隐藏弹窗
        this.handleBoxVisible = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "./index.scss";
</style>
